import {useUniversalModalDispatch} from "@components/context/UniversalModalContext";
import {ModalElement} from "@components/base/overlays/Modal/Modal";
import React from "react";

export function SimpleModal({title, body, onConfirm, type, closeOnConfirm = true, cancelLabel = 'Cancel', confirmLabel = 'OK', size = 'large', confirmButtonClass = undefined}: {
    title?: string,
    body: string | JSX.Element,
    onConfirm: () => void,
    type?: 'success' | 'warning' | 'info' | 'danger' | 'dangerAlert' |  'upgrade',
    size?: 'small' | 'medium' | 'large',
    closeOnConfirm?: boolean,
    confirmLabel?: string,
    cancelLabel?: string | null,
    confirmButtonClass?: string,
}) {
    const {toggle} = useUniversalModalDispatch();
    return <ModalElement size={size}>
        {(type || title) && <ModalElement.Header type={type}>{title}</ModalElement.Header>}
        <ModalElement.Body>
            <p>{body}</p>
        </ModalElement.Body>
        <ModalElement.ButtonContainer>
            <ModalElement.ConfirmButton
                className={confirmButtonClass}
                type={type}
                onConfirm={() => {
                    onConfirm();
                    if (closeOnConfirm) toggle(false)
                }}>
                {confirmLabel}
            </ModalElement.ConfirmButton>
            {cancelLabel !== null &&
                <ModalElement.CancelButton onCancel={() => toggle(false)}>
                    {cancelLabel}
                </ModalElement.CancelButton>}
        </ModalElement.ButtonContainer>
    </ModalElement>
}